// Copyright (c) 2020-2023 Omics Data Automation, Inc.
// Copyright (c) 2023 datma, inc.
//
// Proprietary and Confidential:
// Unauthorized copying of this file by any medium is strictly prohibited.

import { store } from '@/store'
import { fetchWithTimeout } from '@/common/shared'
import { keycloakBaseUrl } from '@/settings'

export const saveProfileChanges = async profileChanges => {
  try {
    const fetchParams = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + store.getters.jwt,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(profileChanges),
    }
    const url = `${keycloakBaseUrl}/account/`
    const response = await fetchWithTimeout(url, fetchParams)
    console.log('response', response)
    if (!response.ok) {
      console.log(`error: status=${response.status}`)
      return []
    }
    return response
  } catch (e) {
    if (e.name === 'AbortError') {
      console.log('timeout error')
    } else {
      console.log('ERROR:', e)
    }
  }
  return []
}
